import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { secondsToTimeString } from "@/react/helpers/dateTimeHelpers";

interface RecordingDurationProps {
  recording_duration: number;
}

export const RecordingDuration = ({
  recording_duration,
}: RecordingDurationProps) => (
  <div>
    <Typography.LabelSm weight="medium">
      {t("live_streams.dashboard.details.recording_duration")}
    </Typography.LabelSm>
    <Typography.BodySm>
      {secondsToTimeString(recording_duration)}
    </Typography.BodySm>
  </div>
);
